import { AppContent, RouterContainer, SpinnerWrapper } from "./styled";
import { Navigate, Route, Routes } from "react-router";
import React, { Suspense, lazy } from "react";

import Breadcrumb from "../components/Breadcrumb";
import { BrowserRouter } from "react-router-dom";
import ProtectedRoute from "../router/ProtectedRoute";
import { ROUTER_PATH } from "./paths";
import Spinner from "@storeblocks/spinner";

const EDHList = lazy(() => import("../features/edhlist"));
const Evidence = lazy(() => import("../features/evidence"));
const Interview = lazy(() => import("../features/interview"));
const Introduction = lazy(() => import("../features/introduction"));
const Beneficiary = lazy(() => import("../features/beneficiary"));
const Signed = lazy(() => import("../features/signing"));
const Result = lazy(() => import("../features/result"));

const NoMatch = (): React.ReactElement => <Navigate to="/" />;

const Loading = (props: any) => {
  return (
    <SpinnerWrapper>
      <Spinner blue={props.blue} />
    </SpinnerWrapper>
  );
};

const showBlueSpinner = window.location.pathname.includes(
  ROUTER_PATH.INTERVIEW,
);
const basename = "helseskjema";
const RootRouter: React.FC = () => {
  return (
    <BrowserRouter basename={basename}>
      <Suspense fallback={<Loading blue={showBlueSpinner} />}>
        <AppContent>
          <RouterContainer>
            <Breadcrumb basename={basename} />
            <Routes>
              <Route path={`/${ROUTER_PATH.MESSAGES}`} element={<Evidence />} />
              <Route
                path={`/:caseId/${ROUTER_PATH.DOCUMENTS}`}
                element={
                  <ProtectedRoute>
                    <Result />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/${ROUTER_PATH.INTERVIEW}`}
                element={
                  <ProtectedRoute>
                    <Interview />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/${ROUTER_PATH.BENEFICIARY}/:beneficiaryOrderId`}
                element={
                  <ProtectedRoute>
                    <Beneficiary />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/${ROUTER_PATH.BENEFICIARY}/:beneficiaryOrderId/dokument/:beneficiaryDocumentId`}
                element={
                  <ProtectedRoute>
                    <Beneficiary />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/${ROUTER_PATH.BENEFICIARY}`}
                element={
                  <ProtectedRoute>
                    <Beneficiary />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/${ROUTER_PATH.SIGNED}`}
                element={
                  <ProtectedRoute>
                    <Signed />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/:edhSigningReference/${ROUTER_PATH.SIGNED}`}
                element={
                  <ProtectedRoute>
                    <Signed />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/:caseId/:step`}
                element={
                  <ProtectedRoute>
                    <Introduction />
                  </ProtectedRoute>
                }
              />
              <Route
                path={`/`}
                element={
                  <ProtectedRoute>
                    <EDHList />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NoMatch />} />
            </Routes>
          </RouterContainer>
        </AppContent>
      </Suspense>
    </BrowserRouter>
  );
};

export default RootRouter;
